import React, { type FC } from 'react'
import { SvgIcon, type SvgIconProps } from '@mui/material'

export const DownloadIcon: FC<SvgIconProps> = (props) => (
    <SvgIcon data-testid="DownloadIcon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g id="icon/download">
            <path
                fill="none"
                id="Vector"
                d="M12 17V3M12 17L6 11M12 17L18 11M19 21H5"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
            </path>
        </g>
    </SvgIcon>
)
